import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    width: p => p.isMobileXS ? p.windowSize.innerWidth - 40 : p.windowSize.innerWidth * 0.5,
    maxWidth: 500,
    height: p => p.isMobileXS ? p.windowSize.innerHeight - 50 : p.windowSize.innerHeight * 0.6,
  },
  headerRow: {
    boxSizing: 'border-box',
    padding: theme.spacing(1),
  }
}));
